export const COLORS = {
  black: "#000000",
  white: "#ffffff",
  themecyan: "#4AD5E4",
  themeyellow: "#FFDB19",
  themeblue: "#213469",
  themered: "#EE4623",
  darkGrey: "rgba(0,0,0,0.7)",
};
